<template>
  <div class="paycools-kyc-page">
    <section class="kyc-content">
      <!-- 标题区 -->
      <header class="kyc-header">
        <el-button type="text" style="padding:0;" @click="$emit('requestBack')">
          <svg-icon icon-class="back" class-name="kyc-back-icon" />
        </el-button>
        <h2 class="kyc-title">{{ $t('kyc.title') }}</h2>
      </header>

      <!-- 表单区 -->
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        class="kyc-form"
      >
        <div v-if="rejectionItems && rejectionItems.length" class="kyc-rejection-box" style="margin-bottom:16px;">
          <el-alert
            type="error"
            :title="$t('kyc.rejection_title')"
            :closable="false"
            show-icon
          >
            <div v-for="(item, index) in rejectionItems" :key="index" class="rejection-item">
              {{ index + 1 }}. {{ item }}
            </div>
          </el-alert>
        </div>
        <!-- 上传卡片区域 -->
        <div class="kyc-upload-grid">
          <div class="kyc-upload-card">
            <div class="kyc-upload-title"><span style="color: #f56c6c;">*</span>{{ $t('kyc.company_document_articles_of_association') }}</div>
            <el-form-item prop="aoa" class="form-item-no-style">
              <UpdateFile
                ref="aoa"
                v-model="form.aoa"
                type="aoa"
                :file-list="fileList"
                :uploading="uploading"
                :remove-files="removeFiles"
                :uploading-progress="uploadingProgress"
                @changeFileList="changeFileList"
                @changeUploading="changeUploading"
                @changeUploadingProgress="changeUploadingProgress"
                @changeRemoveFiles="changeRemoveFiles"
              />
            </el-form-item>
          </div>

          <div class="kyc-upload-card">
            <div class="kyc-upload-title"><span style="color: #f56c6c;">*</span>{{ $t('kyc.company_document_registration_certificate') }}</div>
            <el-form-item prop="sc" class="form-item-no-style">
              <UpdateFile
                ref="sc"
                v-model="form.sc"
                type="sc"
                :file-list="fileList"
                :uploading="uploading"
                :remove-files="removeFiles"
                :uploading-progress="uploadingProgress"
                @changeFileList="changeFileList"
                @changeUploading="changeUploading"
                @changeUploadingProgress="changeUploadingProgress"
                @changeRemoveFiles="changeRemoveFiles"
              />
            </el-form-item>
          </div>

          <div class="kyc-upload-card">
            <div class="kyc-upload-title"><span style="color: #f56c6c;">*</span>{{ $t('kyc.company_document_tax_documents') }}</div>
            <el-form-item prop="br" class="form-item-no-style">
              <UpdateFile
                ref="br"
                v-model="form.br"
                type="br"
                :file-list="fileList"
                :uploading="uploading"
                :remove-files="removeFiles"
                :uploading-progress="uploadingProgress"
                @changeFileList="changeFileList"
                @changeUploading="changeUploading"
                @changeUploadingProgress="changeUploadingProgress"
                @changeRemoveFiles="changeRemoveFiles"
              />
            </el-form-item>
          </div>

          <div class="kyc-upload-card">
            <div class="kyc-upload-title"><span style="color: #f56c6c;">*</span>{{ $t('kyc.company_document_business_permit') }}</div>
            <el-form-item prop="mp" class="form-item-no-style">
              <UpdateFile
                ref="mp"
                v-model="form.mp"
                type="mp"
                :file-list="fileList"
                :uploading="uploading"
                :remove-files="removeFiles"
                :uploading-progress="uploadingProgress"
                @changeFileList="changeFileList"
                @changeUploading="changeUploading"
                @changeUploadingProgress="changeUploadingProgress"
                @changeRemoveFiles="changeRemoveFiles"
              />
            </el-form-item>
          </div>

          <div class="kyc-upload-card">
            <div class="kyc-upload-title"><span style="color: #f56c6c;">*</span>{{ $t('kyc.company_document_license_permit') }}</div>
            <el-form-item prop="lp" class="form-item-no-style">
              <UpdateFile
                ref="lp"
                v-model="form.lp"
                type="lp"
                :file-list="fileList"
                :uploading="uploading"
                :remove-files="removeFiles"
                :uploading-progress="uploadingProgress"
                @changeFileList="changeFileList"
                @changeUploading="changeUploading"
                @changeUploadingProgress="changeUploadingProgress"
                @changeRemoveFiles="changeRemoveFiles"
              />
            </el-form-item>
          </div>

          <div v-if="(form.type_of_business === 2) || (kycData && kycData.company_basic_info && kycData.company_basic_info.type_of_business === 2)" class="kyc-upload-card">
            <div class="kyc-upload-title"><span style="color: #f56c6c;">*</span>{{ $t('kyc.company_document_annual_report') }}</div>
            <el-form-item prop="ar" class="form-item-no-style">
              <UpdateFile
                ref="ar"
                v-model="form.ar"
                type="ar"
                :file-list="fileList"
                :uploading="uploading"
                :remove-files="removeFiles"
                :uploading-progress="uploadingProgress"
                @changeFileList="changeFileList"
                @changeUploading="changeUploading"
                @changeUploadingProgress="changeUploadingProgress"
                @changeRemoveFiles="changeRemoveFiles"
              />
            </el-form-item>
          </div>

          <div class="kyc-upload-card">
            <div class="kyc-upload-title">{{ $t('kyc.company_document_other_documents') }}</div>
            <el-form-item prop="rest_file" class="form-item-no-style">
              <UpdateFile
                ref="rest_file"
                v-model="form.rest_file"
                type="rest_file"
                :file-list="fileList"
                :uploading="uploading"
                :remove-files="removeFiles"
                :uploading-progress="uploadingProgress"
                @changeFileList="changeFileList"
                @changeUploading="changeUploading"
                @changeUploadingProgress="changeUploadingProgress"
                @changeRemoveFiles="changeRemoveFiles"
              />
            </el-form-item>
          </div>
        </div>
      </el-form>

      <!-- 底部按钮 -->
      <div class="kyc-footer">
        <el-button class="kyc-draft-btn" :disabled="isSubmitting" @click="handleSave">{{ $t('kyc.save_as_draft') }}</el-button>
        <el-button class="kyc-next-btn" type="primary" :disabled="isSubmitting" @click="handleNext">{{ $t('kyc.next_step') }}</el-button>
      </div>
    </section>
  </div>
</template>

<script>
import UpdateFile from '@/views/paycools/kyc/UpdateFile'
import { updateCompanyDocument } from '@/api/kyc/kyc'

const fileType = {
  aoa: 16, // 公司章程
  sc: 3, // 公司注册证书
  br: 18, // 公司税务文件
  mp: 4, // 经营许可
  lp: 20, // 牌照
  ar: 2, // 年度报告 (ar: 2)
  rest_file: 17 // 其他文件
}

export default {
  name: 'PaycoolsKycCompanyDocument',
  components: {
    UpdateFile,
    SvgIcon: () => import('@/components/SvgIcon')
  },
  props: {
    kycData: {
      type: Object,
      default: null
    },
    companyFiles: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    submitting: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fileList: {
        aoa: [], // 公司章程
        sc: [], // 公司注册证书
        br: [], // 公司税务文件
        mp: [], // 经营许可
        lp: [], // 牌照
        ar: [], // 年度报告
        rest_file: [] // 其他文件
      },
      uploading: {
        aoa: false, // 公司章程
        sc: false, // 公司注册证书
        br: false, // 公司税务文件
        mp: false, // 经营许可
        lp: false, // 牌照
        ar: false, // 年度报告
        rest_file: false // 其他文件
      },
      uploadingProgress: {
        aoa: 0, // 公司章程
        sc: 0, // 公司注册证书
        br: 0, // 公司税务文件
        mp: 0, // 经营许可
        lp: 0, // 牌照
        ar: 0, // 年度报告
        rest_file: 0 // 其他文件
      },
      fieldRequireTips: {
        aoa: 'Articles of Association', // 公司章程
        sc: 'Company Registration Document', // 公司注册证书
        br: 'Tax Documents', // 公司税务文件
        mp: 'Business Permit', // 经营许可
        lp: 'License Permit', // 牌照
        ar: 'Annual Report', // 年度报告
        rest_file: 'Other Documents' // 其他文件
      },
      form: {
        aoa: null,
        sc: null,
        br: null,
        mp: null,
        lp: null,
        ar: null,
        rest_file: null
      },
      removeFiles: [],
      localSubmitting: false
    }
  },
  computed: {
    isSubmitting() {
      return this.submitting || this.localSubmitting
    },
    rules() {
      const base = {
        aoa: [{
          required: true,
          message: this.$t('kyc.upload_required', { field: this.$t('kyc.company_document_articles_of_association') }),
          trigger: 'change'
        }],
        sc: [{
          required: true,
          message: this.$t('kyc.upload_required', { field: this.$t('kyc.company_document_registration_certificate') }),
          trigger: 'change'
        }],
        br: [{
          required: true,
          message: this.$t('kyc.upload_required', { field: this.$t('kyc.company_document_tax_documents') }),
          trigger: 'change'
        }],
        mp: [{
          required: true,
          message: this.$t('kyc.upload_required', { field: this.$t('kyc.company_document_business_permit') }),
          trigger: 'change'
        }],
        lp: [{
          required: true,
          message: this.$t('kyc.upload_required', { field: this.$t('kyc.company_document_license_permit') }),
          trigger: 'change'
        }]
      }
      const companyType = this.kycData && this.kycData.company_basic_info && this.kycData.company_basic_info.type_of_business
      if (companyType === 2) {
        base.ar = [{
          required: true,
          message: this.$t('kyc.upload_required', { field: this.$t('kyc.company_document_annual_report') }),
          trigger: 'change'
        }]
      }
      return base
    },
    rejectionItems() {
      const audit = this.kycData && this.kycData.audit_info
      if (!audit || audit.kyc_status !== 4) return []
      return (audit.audit_back_list || []).map(item => item.back_content).filter(Boolean).slice(0, 3)
    }
  },
  watch: {
    kycData: {
      handler(newData) {
        if (newData && newData.company_files) {
          this.populateFormData(newData)
        }
      },
      immediate: true
    },
    form: {
      deep: true,
      handler() {
        this.$emit('markChanged')
      }
    }
  },
  methods: {
    changeFileList(config) {
      if (config.push) {
        const { name, url } = config.file
        this.fileList[config.type].push({
          name: name,
          url: url,
          type: fileType[config.type],
          content: config.resData,
          content_oss_url: config.content_oss_url
        })
        this.$set(this.form, config.type, config.resData)
        this.$refs['form'] && this.$refs['form'].clearValidate(config.type)
        return
      } else if (config.delete && config.typeFileList.length === 0) {
        this.form[config.type] = null
        this.$set(this.form, config.type, null)
        this.$refs['form'] && this.$refs['form'].validateField(config.type)
      }
      this.fileList[config.type] = config.typeFileList
    },
    changeUploading(config) {
      this.uploading[config.type] = config.value
    },
    changeUploadingProgress(config) {
      this.uploadingProgress[config.type] = config.value
    },
    changeRemoveFiles(config) {
      if (config.push) {
        const { uid } = config.file
        this.removeFiles.push(uid)
        // this.merchantInfoForm[config.type] = config.resData
        return
      }
    },
    isRequired(type) {
      return ['aoa', 'sc', 'br', 'mp'].includes(type)
    },
    async saveDraft() {
      return new Promise((resolve, reject) => {
        this.$refs['form'].validate((valid, invalidateData) => {
          if (!valid) {
            // 表单验证失败，不在此处弹提示，由父组件统一处理
            reject(new Error('表单验证失败'))
            return
          }
          this.$emit('resetChanged')
          // 验证通过后执行异步保存逻辑
          this.performSave().then(resolve).catch(reject)
        })
      })
    },
    async performSave() {
      // build company_files from fileList using fileType mapping
      const companyFiles = []
      Object.keys(this.fileList || {}).forEach(key => {
        const files = this.fileList[key] || []
        files.forEach(item => {
          const content = item.content
          const name = item.name || ''
          const typeCode = fileType[key] || null
          if (content && typeCode) {
            companyFiles.push({ type: typeCode, content, name })
          }
        })
      })

      const payload = {}

      if (companyFiles.length > 0) {
        for (let index = 0; index < companyFiles.length; index++) {
          if (companyFiles[index].content_oss_url) {
            companyFiles[index].content_oss_url = ''
          }
        }
        payload.company_files = companyFiles
      }
      const result = await updateCompanyDocument(payload)
      this.$emit('saved')
      return result
    },
    async handleSave() {
      if (this.localSubmitting) return
      this.localSubmitting = true
      try {
        await this.saveDraft()
        this.$message.success(this.$t('kyc.save_draft_success'))
      } catch (error) {
        // 错误已在 saveDraft 中处理，这里不需要额外处理
      } finally {
        this.localSubmitting = false
      }
    },
    async handleNext() {
      if (this.localSubmitting) return
      this.localSubmitting = true
      try {
        await this.saveDraft()
        this.$emit('next')
      } catch (error) {
        // 错误已在 saveDraft 中处理，这里不需要额外处理
      } finally {
        this.localSubmitting = false
      }
    },
    populateFormData(data) {
      this.fileList = {
        aoa: [], // 公司章程
        sc: [], // 公司注册证书
        br: [], // 公司税务文件
        mp: [], // 经营许可
        lp: [], // 牌照
        ar: [], // 年度报告
        rest_file: [] // 其他文件
      }
      if (!data) return
      const companyFiles = this.companyFiles || []

      const typeMapping = {
        16: 'aoa', // 公司章程
        3: 'sc', // 公司注册证书
        18: 'br', // 公司税务文件
        4: 'mp', // 经营许可
        20: 'lp', // 牌照
        2: 'ar', // 年度报告 (ar:2)
        17: 'rest_file' // 其他文件
      }

      // Process each company file
      companyFiles.forEach(file => {
        const formKey = typeMapping[file.type]
        if (formKey) {
          this.fileList[formKey].push({
            name: file.name || `${formKey}.pdf`,
            url: file.content_oss_url || file.content,
            content: file.content,
            content_oss_url: file.content_oss_url || file.content
          })
          this.$set(this.form, formKey, file.content)
          this.$refs['form'] && this.$refs['form'].clearValidate(formKey)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.paycools-kyc-page {
  display: flex;
  align-items: stretch;
  background-color: #f5f7fb;
  min-height: calc(100vh - 80px);
  box-sizing: border-box;
}

.kyc-sidebar {
  width: 240px;
  background-color: #f7f8fc;
  border-radius: 8px;
  padding: 24px 0;
  box-shadow: 0 0 0 1px #edf0f7;
}

.kyc-step-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.kyc-step-item {
  display: flex;
  align-items: center;
  padding: 12px 24px;
  font-size: 14px;
  color: #7b8192;
  cursor: default;
}

.kyc-step-item.is-active {
  background-color: #ffffff;
  color: #2f3a60;
  font-weight: 600;
  border-left: 3px solid #3b82f6;
}

.kyc-step-index {
  margin-right: 8px;
}

.kyc-step-label {
  flex: 1;
}

.kyc-content {
  flex: 1;
  margin-left: 32px;
  background-color: #ffffff;
  border-radius: 8px;
  padding: 32px 40px 32px;
  box-shadow: 0 8px 20px rgba(15, 35, 95, 0.04);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.kyc-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
}

.kyc-title {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #1f2937;
}

.kyc-upload-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px 32px;
  margin-bottom: 32px;
}

.kyc-upload-card {
  display: flex;
  flex-direction: column;
}

.kyc-upload-title {
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 12px;
}

.kyc-upload-box {
  border-radius: 8px;
  border: 1px dashed #d1d5db;
  background-color: #fafbff;
  padding: 24px 16px;
  text-align: center;
  color: #6b7280;
}

.kyc-upload-icon {
  font-size: 20px;
  color: #9ca3af;
  margin-bottom: 8px;
}

.kyc-upload-main-text {
  font-size: 14px;
  color: #2563eb;
  font-weight: 500;
  margin-bottom: 8px;
}

.kyc-upload-sub-text {
  font-size: 12px;
  line-height: 1.5;
  margin-bottom: 4px;
}

.kyc-upload-tip {
  font-size: 12px;
  color: #9ca3af;
}

.kyc-footer {
  margin-top: auto;
  padding-top: 16px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  gap: 16px;
  align-items: center;
}

.kyc-draft-btn {
  flex: 1;
  height: 44px;
  font-size: 16px;
  font-weight: 500;
  background-color: #ffffff;
  color: #3b82f6;
  border: 1px solid #3b82f6;
  border-radius: 6px;
}

.kyc-next-btn {
  flex: 1;
  height: 44px;
  font-size: 16px;
  font-weight: 500;
  background-color: #3b82f6;
  color: #ffffff;
  border: none;
  border-radius: 6px;
}

.form-item-no-style {
  margin-bottom: 0;

  .el-form-item__content {
    margin-left: 0;
  }

  .el-form-item__error {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    margin-top: 4px;
  }
}

.rejection-item {
  margin-bottom: 4px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>

